// extracted by mini-css-extract-plugin
export default {"modalBody":"SelectReleaseGroupModalContent-modalBody-tIpUk ModalBody-modalBody-RVK6D"};